import { createContext } from 'react';

export const EditBankAccountDrawerContext = createContext(null);
